import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowCollapseRightIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 25.6 25.6",
	style: { enableBackground: "new 0 0 25.6 25.6" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.arrow_collapse_right-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.arrow_collapse_right-icon-st1{fill:currentColor;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}\n"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_right-icon-st0",
			d: "M12.7,8.1l4.7,4.7l-4.7,4.7"
		}), /* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_right-icon-st0",
			d: "M4.9,12.8h12.5"
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "arrow_collapse_right-icon-st1",
			d: "M4,25.1h17.6c1.9,0,3.5-1.6,3.5-3.5V4c0-1.9-1.6-3.5-3.5-3.5H4C2.1,0.5,0.5,2.1,0.5,4v17.6 C0.5,23.5,2.1,25.1,4,25.1z M1.5,3.8c0-1.3,1.1-2.4,2.4-2.4h14.6c1.3,0,2.4,1.1,2.4,2.4v17.8c0,1.3-1.1,2.4-2.4,2.4H3.9 c-1.3,0-2.4-1.1-2.4-2.4V3.8z"
		})
	]
});
export default SvgArrowCollapseRightIcon;
